export const formatPercent = (rate: number): string =>
    `${(rate * 100).toFixed(1)}%`

export const formatCurrency = (value: number): string =>
    new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
    }).format(Number.isFinite(value) ? value : 0)

export const formatNumber = (value: number): string =>
    new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 1,
    }).format(Number.isFinite(value) ? value : 0)
